// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"04039853","453":"2b54f994"}[chunkId] + ".chunk.js";
};